import React, { useState, useEffect, useCallback } from "react";
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Preloader from "../Preloader";


const TestimonialSlider = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = apiBaseUrl+`testimonial`;
  const [data, setData] = useState([]);
  const [title, setTitle] = useState([]);
  const [loading, setLoading] = useState(true)


  useEffect(() => {
    const fetchPagedata = async () => {
        setLoading(true);
        try {
            const [testiRes, titleRes] = await Promise.all([
            axios.get(apiUrl),
            axios.get(apiBaseUrl + "pagetitle"),
            ]);
            setData(testiRes.data);
            setTitle(titleRes.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        };
        setLoading(false);
    }
    fetchPagedata();
  }, []);

  
  function displayRatting(cntr){
    let starRatings = [];
    for (let i = 0; i < cntr; i++) {
        starRatings.push(
         <i className="flaticon-star" key={i}></i>
        );
    }
    return starRatings;   
  }

    return (
        <section className="testimonials-one">
            <div className="testimonials-one__shape-one" style={{ backgroundImage: 'url(assets/images/shapes/testimonials-1-shape-1.png)' }}></div>
            <div className="testimonials-one__shape-two" style={{ backgroundImage: 'url(assets/images/shapes/testimonials-1-shape-2.png)' }}></div>
            <div className="testimonials-one__shape-three" style={{ backgroundImage: 'url(assets/images/shapes/testimonials-1-shape-3.png)' }}></div>
            <div className="testimonials-one__shape-four" style={{ backgroundImage: 'url(assets/images/shapes/testimonials-1-shape-4.png)' }}></div>
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-lg-6 wow fadeInUp" data-wow-delay="100ms">
                        <div className="testimonials-one__image">
                            <div className="testimonials-one__image__bg" style={{ backgroundImage: 'url(assets/images/shapes/testimonial-1-image-bg.png)' }}></div>
                            <img src="assets/images/resources/testimonial-1-image.png" alt="growim"/>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="testimonials-one__area">
                            <div className="sec-title text-left">
                                <h6 className="sec-title__tagline">{ title?.testi_heading }</h6>
                                <h3 className="sec-title__title">{ title?.testi_sub_heading }</h3>
                            </div>
                            { loading && <Preloader />}
                            <Swiper
                                className="testimonials-one__carousel growim-owl__carousel"
                                modules={[ Pagination, Autoplay]}
                                spaceBetween={0}
                                slidesPerView={1}
                                pagination={{ clickable: true }}
                                autoplay={{ delay:6000 }}
                                loop={true}
                                onSwiper={(swiper) => console.log(swiper)}
                            >
                            { data.map(( item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <div className="item">
                                            <div className="testimonials-one__item">
                                                <div className="testimonials-one__item__rating">
                                                    { displayRatting(item.ratting) }
                                                </div>
                                                <div className="testimonials-one__item__content" dangerouslySetInnerHTML={{  __html: item?.comments }}></div>
                                                <div className="testimonials-one__item__author">
                                                    <img src={ item?.image } alt={ item?.name }/>
                                                    <h3 className="testimonials-one__item__name">
                                                        { item?.name }
                                                    </h3>
                                                    <p className="testimonials-one__item__designation">{ item?.designation }</p>
                                                </div>
                                                <div className="testimonials-one__item__quote"><i className="flaticon-quote"></i></div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )
                            })}
                            </Swiper>

                        </div>
                    </div>
                </div>
            </div>
        </section>   
  )
}

export default TestimonialSlider